import * as emailOtpFlow from "./flows/emailOtp";
import * as passwordFlow from "./flows/password";
import { Session } from "./utils/session";

export function MagikAuth() {
  return {
    ...emailOtpFlow,
    ...passwordFlow,
    session: Session
  };
}